import type { AssociatedStatus } from '@/entities/optimization'
import type { OptimizationGroupTableRow } from '../model/types'

import { getAssociatedStatus } from '@/entities/optimization'

import { OptimizationStatus } from '@/shared/generated'

export const groupByStatus = (groups: OptimizationGroupTableRow[]) => {
	const statuses: Record<AssociatedStatus, OptimizationGroupTableRow[]> = {
		[OptimizationStatus.New]: [],
		[OptimizationStatus.Scheduled]: [],
		[OptimizationStatus.Pending]: [],
		[OptimizationStatus.Failed]: [],
		[OptimizationStatus.Finished]: [],
		[OptimizationStatus.Locked]: [],
	}

	return groups.reduce((result, item) => {
		const status = getAssociatedStatus(item?.optimization?.status)

		if (!status) {
			return result
		}
		result[status as AssociatedStatus] ||= []
		result[status as AssociatedStatus].push(item)

		return result
	}, statuses)
}
